import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { DataRevisionIndicator } from '../../shared';
import { MicrobiologyColDef } from './microbiology.component';
import { MicrobiologyGridRowItem } from './microbiology-grid-row-item';
import { ModalData } from '../standard-test-results/model-dialog/data-revision/data-revision.component';
import { ModalDialogService } from '../standard-test-results/model-dialog/ModalDialogService';
import { MicrobiologyData } from './microbiology-data';
import { DataChangeDetails } from './culture-details-ag-renderer.component';


@Component({
    selector: 'culture-group-cell',
    template: require('./culture-group-ag-renderer.component.html'),
    styles: [require('./culture-group-ag-renderer.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class CultureGroupAgRendererComponent implements AgRendererComponent {

    public groupType: string;
    public groupValue: string;
    public dataRevisionText: string;
    public childrenCounter: number;

    public hasDataRevision: boolean;
    public isCancelled: boolean;


    public labtestId: number;
    public protocol: string;
    public participantNumber: string;
    public investigatorNumber: string;
    public accessionNumber: string;
    public visitDescription: string;
    public requestType: string;

    constructor(private dataRevisionIndicator: DataRevisionIndicator, public modalDialogService: ModalDialogService) {}

    public refresh() {
        return false;
    }

    public agInit(params: MicrobiologyGridRowItem): void {

        const changeddata = params?.node?.allLeafChildren?.[0]?.data?.dataChangeDetails as DataChangeDetails;

        this.labtestId = changeddata?.microTestId;
        this.protocol = 'Loading..';
        this.participantNumber = changeddata?.subjectNumber;
        this.investigatorNumber = 'Loading..';
        this.accessionNumber = changeddata?.accessionNumber;
        this.visitDescription = changeddata?.visitDescription;

        const groupColumn = params.api.getColumnDef(params.node.field) as MicrobiologyColDef;
        if (groupColumn) {
            this.groupType = groupColumn.headerName;

            if (groupColumn.hasDataRevision && groupColumn.getDataRevisionMessage) {
                this.hasDataRevision = params.node.allLeafChildren.some(e => e.data && groupColumn.hasDataRevision(e.data));
                if (this.hasDataRevision) {
                    this.dataRevisionText = groupColumn.getDataRevisionMessage(this.dataRevisionIndicator);
                }
            }

            if (groupColumn.isCancelled) {
                this.isCancelled = params.node.allLeafChildren.some(e => e.data && groupColumn.isCancelled(e.data));
            }
        }

        this.childrenCounter = params.node.childrenAfterFilter.length;
        this.groupValue = params.node.key;
    }

    public openpopup(labtestId: number) {

        if (this.groupType.toUpperCase() === 'SUBJECT' || this.groupType.toUpperCase() === 'VISIT') {
            this.requestType = this.groupType.toUpperCase();
        } else {
            this.requestType = 'RESULT';
        }
            
        let data: ModalData = {
            title: 'Data Change',
            data: [],
            protocol: this.protocol,
            participantNumber: this.participantNumber,
            investigatorNumber: this.investigatorNumber,
            accessionNumber: this.accessionNumber,
            visitDescription: this.visitDescription,
            closeButtonText: 'Close',
            reverseButtons: true,
            displayClose: false,
            type: 'MICRO' + this.requestType,
            labTestId: labtestId
        };
        if (this.requestType === 'SUBJECT' || this.requestType === 'VISIT' || this.requestType === 'RESULT') {
            this.modalDialogService.showDialog(data).toPromise();
        }
    }
}